import * as React from 'react';
import ImageSlider from 'react-slick';
import './styles/ImageSlider.scss';

export default pros => <ImageSlider {...pros} />;

